import styled from "styled-components";

import { theme } from "../../../../styles/theme";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export const CardContent = styled.div`
  width: 90%;
  height: 85%;
  background-color: ${theme.colors.darkBlue};
  border-radius: 20px;
  padding: 30px 60px 30px 60px;
  margin: 0 auto;
  overflow: auto;

  ::-webkit-scrollbar {
    width: 8px !important;
  }

  ::-webkit-scrollbar-track {
    background-color: ${theme.colors.blue800} !important;
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.gray800} !important;
    border-radius: 0 !important;
  }

  @media screen and (max-width: 479px) {
    width: 100%;
    padding: 10px;
  }
`;
